export interface IErrorState {
    isInError: boolean;
    isValidValue: boolean;
    message?: string;
    errorType?: 'RequiredField' | 'NotValid' | 'NotEligible' | 'ThirdParty';
    required: boolean;
}

interface ISetValidAction {
    type: 'setValid';
    target: string;
    payload: boolean;
    errorType?: IErrorState['errorType'];
}

interface IBatchSetValidAction {
    type: 'batchSetValid';
    payload: Record<string, IErrorState>;
}

export type TAction = ISetValidAction | IBatchSetValidAction;

type TState = Record<string, IErrorState>;

function setValid(state: TState, action: ISetValidAction) {
    const newState = JSON.parse(JSON.stringify(state));
    newState[action.target].isValidValue = action.payload;
    newState[action.target].isInError = !action.payload;
    newState[action.target].errorType = action.payload
        ? undefined
        : action.errorType ?? newState[action.target].errorType;
    return newState;
}

function batchSetValid(state: TState, { payload }: IBatchSetValidAction) {
    const newState = JSON.parse(JSON.stringify(state));
    for (const key in payload) {
        newState[key] = JSON.parse(JSON.stringify(payload[key]));
    }
    return newState;
}

export default function errorReducer(
    state: Record<string, IErrorState>,
    action: TAction,
): Record<string, IErrorState> {
    switch (action.type) {
    case 'setValid':
        return setValid(state, action);
    case 'batchSetValid':
        return batchSetValid(state, action);
    }
}
